class BaseModule {

	constructor(el) {

		if(!el || !el.length){
			throw new Error("super() requires el parameter.");
		}

		this.$el = $(el);

		// flags

		this._isDestroyed = false;
		this._isDomReady = false;
		this._isEnabled = false;
		this._isListening = false;
		this._isShowing = false;

		this._autoEnable = true;

		// add attr identifying $el as module

		this.$el.attr('data-js-module', '');

		// allow external access to module

		this._configEventMethods();

		//

		$(() => {
			window.SETTINGS.animationFrame.one(() => {
				this.domReady();
			});
		});
	}

	// COMPLETE THESE METHODS WHEN INHERITING BASEMODULE --------------------------------------  //

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

	// CORE FUNCTIONALITY BELOW - DO NOT EDIT - DO NOT INHERIT --------------------------------  //

	// public & event-linked methods

	domReady(){

		if(!this._isDomReady){

			if(this._autoEnable){ this.enable(); }

			this._isDomReady = true;
			this._domReady();
		}
	}

	addListeners(){

		if(!this._isListening){

			this._isListening = true;

			//

			window.vent.on('domUpdate', this._onDomUpdate, this);
			window.vent.on('windowResize', this._onResize, this);

			this._addListeners();
			this._resize();
		}
	}

	removeListeners(){

		if(this._isListening){

			this._isListening = false;

			window.vent.off('domUpdate', this._onDomUpdate, this);
			window.vent.off('windowResize', this._onResize, this);

			this._removeListeners();
		}
	}

	show(){

		if(!this._isShowing && !this._isDestroyed){
			this._isShowing = true;
			this.enable();
			this._show();
		}
	}

	hide(){

		if(this._isShowing && !this._isDestroyed){
			this._isShowing = false;
			this.disable();
			this._hide();
		}
	}

	enable(){

		if(!this._isEnabled && !this._isDestroyed){
			this._isEnabled = true;
			this.addListeners();
			this._enable();
		}
	}

	disable(){

		if(this._isEnabled && !this._isDestroyed){
			this._isEnabled = false;
			this.removeListeners();
			this._disable();
		}
	}

	destroy(){

		if(!this._isDestroyed){
			this._isDestroyed = true;
			this.disable();
			this.$el.remove();
		}
	}

	// global event listeners

	_onDomUpdate(){
		this._domUpdate();
	}

	_onResize(){
		this._resize();
	}

	// listeners linked to public methods -----------------------------------------------------  //

	_configEventMethods(){

		// events linked to methods (do this often)

		this.$el.on('enable', this.enable.bind(this));
		this.$el.on('disable', this.disable.bind(this));
		this.$el.on('show', this.show.bind(this));
		this.$el.on('hide', this.hide.bind(this));
		this.$el.on('destroy', this.destroy.bind(this));

		// link to module from $el object (use with caution)

		let className = this.constructor.name;

		if(!this.$el[0].modules){ this.$el[0].modules = {}; }
		this.$el[0].modules[className] = this;
	}

	// utils ----------------------------------------------------------------------------------  //

	checkVal(val, fallbackVal, emptyVal){

		// check val
		// if invalid, return fallbackVal
		// if empty, return emptyVal

		if(typeof(val) !== 'undefined'){
			if(val === '' && typeof(emptyVal) !== undefined){ return emptyVal; }
			else if(val !== null && !(typeof(val) === 'number' && isNaN(val)) && !(val instanceof jQuery && !val.length)){ return val; }
		}

		return fallbackVal;
	}

	checkVals(vals, fallbackVal, emptyVal){

		// check values (requires an array)
		// if invalid, return fallbackVal
		// if empty, return emptyVal

		if(typeof(vals) !== 'undefined' && vals.length){

			let failObj = {failed:true};

			for(let i=0; i<vals.length; i++){
				let returnVal = this.checkVal(vals[i], failObj, failObj);
				if(returnVal !== failObj){ return returnVal; }
			}
		}

		return fallbackVal;
	}

	triggerEvent(eventName, obj){

		let stdReturnObj = {
			module: this,
			$el: this.$el
		};

		this.$el.triggerHandler(eventName, $.extend({}, stdReturnObj, obj));
	}
}

module.exports = BaseModule;
